<template>
  <div class="text-center">
    <v-card v-if="form !== null" style="position: relative">
      <v-card
        flat
        style="
          z-index: 2;
          position: sticky;
          top: 0;
          background: white;
          border-bottom: 1.5px solid indigo;
          margin-bottom: 10px;
          display: flex;
          justify-content: space-between;
        "
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 10px;
          "
        >
          <v-toolbar-title class="overline">
            <p
              style="
                font-size: 18px;
                margin: 0;
                font-weight: bold;
                color: indigo;
              "
            >
              Detail Pengelolaan Aset
              <v-tooltip bottom color="grey">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    x-small
                    text
                    icon
                    color="grey darken-2"
                    style="position: relative; top: -3px"
                    @click="getDetailData()"
                  >
                    <v-icon small>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>refresh page</span>
              </v-tooltip>
            </p>
          </v-toolbar-title>
        </div>
        <div>
          <router-link to="/asset-management/aset-kepemilikan">
            <v-btn
              text
              color="black"
              class="black--text font-weight-bold"
              small
              type="button"
              outlined
            >
              <v-icon x-small>mdi-arrow-left-bold</v-icon>
              Kembali
            </v-btn>
          </router-link>
        </div>
      </v-card>
      <v-form
        ref="formAssetRef"
        lazy-validation
        @submit.prevent="saveForm"
        style="position: relative"
        :readonly="!editHeader"
        :loading="loading"
      >
        <div style="position: absolute; top: -5px; right: 10px">
          <v-btn
            v-if="editHeader"
            outlined
            type="submit"
            text
            color="green darken-2"
            class="font-weight-bold mr-2"
            x-small
          >
            Simpan
          </v-btn>
          <v-btn
            v-if="editHeader"
            outlined
            type="button"
            text
            color="red darken-2"
            class="font-weight-bold"
            x-small
            @click.prevent="
              loading = !loading
              editHeader = false
            "
          >
            Batal
          </v-btn>
          <v-btn
            v-if="!editHeader"
            outlined
            type="button"
            text
            color="blue darken-2"
            class="font-weight-bold"
            x-small
            @click.prevent="
              loading = !loading
              editAssetHeader()
            "
          >
            <v-icon x-small>mdi-pencil</v-icon>
            Edit
          </v-btn>
        </div>
        <v-row no-gutters style="padding: 15px">
          <v-col cols="12" md="5" style="padding: 0">
            <div style="padding: 0 10px">
              <v-col cols="12" style="padding: 0">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Nama Aset
                </p>
              </v-col>
              <v-col cols="12" style="padding: 0">
                <v-text-field
                  v-model="form.name"
                  dense
                  outlined
                  :readonly="!editHeader"
                />
              </v-col>
            </div>
          </v-col>
          <v-col cols="12" md="2" style="padding: 0"></v-col>
          <v-col cols="12" md="5" style="padding: 0">
            <div style="padding: 0 10px">
              <v-col cols="12" style="padding: 0">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Kode Aset
                </p>
              </v-col>
              <v-col cols="12" style="padding: 0">
                <v-text-field
                  :value="form.code"
                  dense
                  outlined
                  readonly
                  :disabled="editHeader"
                />
              </v-col>
            </div>
          </v-col>

          <v-col cols="12" md="5" style="padding: 0">
            <div style="padding: 0 10px">
              <v-col cols="12" style="padding: 0">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Jumlah Stock
                </p>
              </v-col>
              <v-col cols="12" style="padding: 0">
                <v-text-field
                  :value="form.total_stock"
                  dense
                  outlined
                  readonly
                  :disabled="editHeader"
                />
              </v-col>
            </div>
          </v-col>
          <v-col md="2" style="padding: 0"></v-col>
          <v-col cols="12" md="5" style="padding: 0">
            <div style="padding: 0 10px">
              <v-col cols="12" style="padding: 0">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Kategori Aset
                </p>
              </v-col>
              <v-col cols="12" style="padding: 0">
                <v-select
                  dense
                  v-model="form.category"
                  :items="dropdownCategory"
                  item-text="name"
                  item-value="id"
                  return-object
                  outlined
                  :readonly="!editHeader"
                ></v-select>
              </v-col>
            </div>
          </v-col>

          <v-col cols="12" md="5" style="padding: 0">
            <div style="padding: 0 10px">
              <v-col cols="12" style="padding: 0">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Current Stock
                </p>
              </v-col>
              <v-col cols="12" style="padding: 0">
                <v-text-field
                  :value="form.current_stock"
                  dense
                  outlined
                  readonly
                  type="number"
                  :disabled="editHeader"
                />
              </v-col>
            </div>
          </v-col>
          <v-col md="2" style="padding: 0"></v-col>
          <v-col cols="12" md="5" style="padding: 0">
            <div style="padding: 0 10px">
              <v-col cols="12" style="padding: 0">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Satuan
                </p>
              </v-col>
              <v-col cols="12" style="padding: 0">
                <v-select
                  dense
                  v-model="form.unit"
                  :items="getDropdownUnit"
                  item-text="name"
                  item-value="id"
                  return-object
                  outlined
                  :clearable="editHeader"
                  :readonly="!editHeader"
                ></v-select>
              </v-col>
            </div>
          </v-col>
          <v-col md="2" style="padding: 0"></v-col>
        </v-row>
      </v-form>

      <v-expansion-panels v-model="panel" multiple class="mb-1" elevation="1">
        <v-expansion-panel>
          <v-expansion-panel-header
            expand-icon="mdi-menu-down"
            style="
              font-weight: bold;
              font-size: 16px;
              margin: 0;
              font-weight: bold;
              color: indigo;
            "
            >MANAGE LOT
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row no-gutters style="padding: 15px">
              <v-col>
                <lot-management
                  :assetDetail="{
                    id: asset_id,
                    code: asset_code
                  }"
                  :lot="detailLot"
                  @loadPage="getDetailData"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            expand-icon="mdi-menu-down"
            style="
              font-weight: bold;
              font-size: 16px;
              margin: 0;
              font-weight: bold;
              color: indigo;
            "
            >RIWAYAT PEMINDAHAN
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row
              v-if="movementHistory !== null"
              no-gutters
              style="padding: 0; margin-top: 10px"
            >
              <v-col cols="12" style="padding: 0">
                <v-timeline dense>
                  <v-timeline-item
                    small
                    v-for="(item, index) in movementHistory"
                    :key="index"
                    :color="index % 2 === 0 ? 'indigo' : 'green'"
                  >
                    <v-card
                      v-if="item.movement_status == 2"
                      :color="index % 2 === 0 ? 'indigo' : 'green'"
                      dark
                      style="max-width: 300px; overflow: hidden"
                    >
                      <div class="ribbon">{{ item.movement_status_label }}</div>
                      <v-card-text class="white text--primary text-left">
                        <!-- <strong style="font-size: 18px">{{
                          convertDate(item.received_at)
                        }}</strong> -->
                        <br />
                        <strong>{{ item.destination_company_name }}</strong>
                        <h6 style="margin: 0">
                          Gudang: {{ item.placed_location_name }}
                        </h6>
                        <div class="text-caption">
                          <p style="margin: 0">Doc No : {{ item.doc_no }}</p>
                          <p style="margin: 0">
                            Diterima oleh : {{ item.received_by_name }}
                          </p>
                          <!-- prettier-ignore -->
                          <p style="margin: 0">
                            Tgl. Terima :
                            {{
                              convertDate(item.received_at)
                            }}
                          </p>
                          <p style="margin: 0">Qty : {{ item.qty }}</p>
                          <p style="margin: 0">
                            Status :
                            <span
                              v-if="item.detail_status == 1"
                              :style="`color: ${
                                item.detail_status == 1 ? 'green' : 'red'
                              }`"
                              >{{ item.detail_status_label }}</span
                            >
                          </p>
                        </div>
                        <v-btn
                          style="margin-top: 10px"
                          :color="index % 2 === 0 ? 'indigo' : 'green'"
                          outlined
                          small
                          @click="detailMovement(item.move_id)"
                        >
                          Lihat Dokumen
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import buildType from '../../../services/buildType'
import moment from 'moment'
export default {
  name: 'Asset-Detail',
  components: {
    LotManagement: () => import('./components/LotList')
  },
  data() {
    return {
      asset: buildType.apiURL('asset'),
      eSanqua: buildType.apiURL('esanqua'),
      dialog: false,
      form: null,
      loading: false,
      detailLot: null,
      asset_id: null,
      asset_code: null,
      editHeader: false,
      dropdownCategory: [],
      movementHistory: null,
      panel: [0]
    }
  },
  computed: {
    ...mapGetters(['getParamAsset', 'getDropdownUnit'])
  },
  mounted() {
    this.getDetailData()

    this.dropdownAssetCategory().then((res) => {
      this.dropdownCategory = res
    })
    this.dropdownUnit()
  },
  methods: {
    ...mapActions(['dropdownAssetCategory', 'dropdownUnit']),
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    editAssetHeader() {
      setTimeout(() => {
        // this.$refs.formAssetRef.focus()
        this.editHeader = true
      }, 100)
    },
    saveForm() {
      const xForm = {
        act: 'update',
        id: this.form.id,
        name: this.form.name,
        code: this.form.code
      }
      if (this.form.category && this.form.category.id) {
        Object.assign(xForm, {
          category_id: this.form.category.id,
          category_name: this.form.category.name
        })
      }
      if (this.form.company && this.form.company.id) {
        Object.assign(xForm, {
          company_id: this.form.company.id,
          company_name: this.form.company.name
        })
      }
      if (this.form.unit && this.form.unit.id) {
        Object.assign(xForm, {
          unit_id: this.form.unit.id,
          unit_name: this.form.unit.name
        })
      }
      console.log('Add Asset>>>', xForm)
      this.showMsgDialog(
        'question',
        'Anda yakin ingin merubah data ini?',
        true
      ).then((res) => {
        if (res.isConfirmed) {
          this.loading = true
          axios
            .post(`${this.asset}asset/save`, xForm)
            .then((res) => {
              if (res.data.status_code == '00') {
                this.editHeader = false
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDetailData()
              } else {
                this.loading = false
                if (res.data.status_msg === 'Parameter value has problem') {
                  this.showMsgDialog(
                    'error',
                    'Invalid input, Parameter value has problem',
                    false
                  )
                } else {
                  this.showMsgDialog('error', res.data.status_msg, false)
                }
              }
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    async getDetailData() {
      this.detailLot = null
      await axios
        .get(`${this.asset}asset/detail/${this.getParamAsset.id}`)
        .then((res) => {
          console.log('response detail asset', res)
          if (res.data.status_code == '00') {
            this.form = res.data.data
            this.asset_id = res.data.data.id
            this.asset_code = res.data.data.code
            if (res.data.data.unit_id) {
              Object.assign(this.form, {
                unit: {
                  id: res.data.data.unit_id,
                  name: res.data.data.unit_name
                }
              })
            }
            this.getMovementHistory()
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
          }
        })
        .catch((err) => {
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })

      console.log(this.getParamAsset.id)
      await axios
        .get(`${this.asset}asset/lot/list?asset=${this.getParamAsset.id}`)
        .then((res) => {
          if (res.data.status_code == '00') {
            console.log(res)
            this.detailLot = res.data.data
          }
          // else {
          //   this.showMsgDialog('warning', res.data.status_msg, false)
          // }
        })
        .catch((err) => {
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    async getMovementHistory() {
      await axios
        .get(`${this.asset}movement/history/${this.asset_code}`)
        .then((res) => {
          if (res.data.status_code == '00') {
            // console.log('response detail history', res.data.data.history)
            res.data.data.history.sort(
              (a, b) =>
                moment(b.received_at, 'DD-MMM-YYYY HH:mm:ss') -
                moment(a.received_at, 'DD-MMM-YYYY HH:mm:ss')
            )
            this.movementHistory = res.data.data.history
          }
        })
        .catch((err) => {
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    convertDate(raw) {
      if (raw == null) return '-'
      const d = new Date(raw)
      const localDate = d.toLocaleString('id')
      // const newDate = localDate.slice(0, localDate.indexOf(' '))
      return localDate
    },
    detailMovement(id) {
      window.open(`/asset-management/detail-penerimaan/${id}`, '_blank')
      // this.$router.push(`/asset-management/detail-penerimaan/${id}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.ribbon {
  position: absolute;
  top: 15px;
  right: -25px;
  transform: rotate(45deg);
  background: #28a745;
  color: #fff;
  padding: 4px 30px;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
}
</style>
